import {
    Button, ListItemIcon, ListItemText, MenuItem,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import {
    useNavigate,
} from 'react-router-dom'
import useStyles from './CreateButton.styles'

type Props = {
    isMenuItem?: boolean
}
const CreateButton = ({
    isMenuItem = false,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()
    const navigate = useNavigate()

    const handleCreate = () => {
        navigate('./create')
    }

    if (isMenuItem) {
        return (
            <MenuItem
                onClick={handleCreate}
                data-testid="create-menu-item"
            >
                <ListItemIcon>
                    <div className={classes.button}>
                        <AddIcon
                            className={classes.icon}
                        />
                    </div>
                </ListItemIcon>
                <ListItemText>
                    Add New
                </ListItemText>
            </MenuItem>
        )
    }

    return (
        <Button
            className={classes.button}
            onClick={handleCreate}
            type="button"
            data-testid="create-button"
        >
            <AddIcon
                className={classes.icon}
            />
        </Button>
    )
}

export default CreateButton
